import React from "react";
import { useNav } from "../customHooks/useNav";
import headshot from "../img/willemdatema.webp";
import "./Page.css";

const Contact = () => {
  const contactRef = useNav("Contact");

  return (
    <section ref={contactRef} id="contactContainer" className="contact-section">
      <div className="section-inner contact-grid">
        <div>
          <div className="numbered-label" style={{ color: "var(--color-accent-2-300)" }}>05</div>
          <h2 className="contact-heading">Contact</h2>
          <p className="contact-intro">
            Ik kom graag met je in contact! Voeg me toe op LinkedIn of bekijk
            mijn Github pagina.
          </p>
          <div className="contact-actions">
            <a
              href="http://linkedin.com/in/willem-datema-58b24647/"
              target="_blank"
              rel="noreferrer"
              className="btn btn-primary"
            >
              LinkedIn
            </a>
            <a
              href="https://github.com/Willeem"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline"
            >
              GitHub
            </a>
          </div>
        </div>
        <div className="contact-footer">
          <img src={headshot} alt="Willem Datema" />
          <div className="contact-footer-name">Willem Datema · Utrecht</div>
          <div className="contact-footer-year">© {new Date().getFullYear()}</div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
